import classes from './TechStack.module.css';
import pythonlogo from '../images/pythonlogo.png';
import clogo from '../images/C++logo.png';
import react from '../images/reactlogo.png'
import js from '../images/jslogo.jpg';
import html from '../images/htmllogo.png';
import css from '../images/csslogo.png';
import figma from '../images/figmalogo.png';
import r from '../images/rlogo.png';
import node from '../images/nodejs.png';
import typescript from '../images/typescript.png';
import sass from '../images/sass.png';

function TechStack() {
    return (
        <div className={classes.container}>
            <div className={classes.title}>
                Tech Stack
            </div>
            <div className={classes.icons}>
                <div className={classes.icontickerwrap}>
                    <div className={classes.iconmove}>
                        <div className={classes.tickeritem}>
                            <img className={classes.image} src={pythonlogo} alt='Python logo' />
                        </div>
                        <div className={classes.tickeritem}>
                            <img className={classes.image} src={js} alt='JS logo' />
                        </div>
                        <div className={classes.tickeritem}>
                            <img className={classes.tsimage} src={typescript} alt='Typescript logo' />
                        </div>
                        <div className={classes.tickeritem}>
                            <img className={classes.cimage} src={clogo} alt='C++ logo' />
                        </div>
                        <div className={classes.tickeritem}>
                            <img className={classes.image} src={react} alt='React logo' />
                        </div>
                        <div className={classes.tickeritem}>
                            <img className={classes.image} src={html} alt='HTML logo' />
                        </div>
                        <div className={classes.tickeritem}>
                            <img className={classes.cssimage} src={css} alt='CSS logo' />
                        </div>
                        <div className={classes.tickeritem}>
                            <img className={classes.sassimage} src={sass} alt='Sass logo' />
                        </div>
                        <div className={classes.tickeritem}>
                            <img className={classes.nodeimage} src={node} alt="Node logo" />
                        </div>
                        <div className={classes.tickeritem}>
                            <img className={classes.figimage} src={figma} alt='figma logo' />
                        </div>
                        <div className={classes.tickeritem}>
                            <img className={classes.rimage} src={r} alt='R logo' />
                        </div>
                        <div className={classes.tickeritem}>
                            <img className={classes.image} src={pythonlogo} alt='Python logo' />
                        </div>
                        <div className={classes.tickeritem}>
                            <img className={classes.image} src={js} alt='JS logo' />
                        </div>
                        <div className={classes.tickeritem}>
                            <img className={classes.tsimage} src={typescript} alt='Typescript logo' />
                        </div>
                        <div className={classes.tickeritem}>
                            <img className={classes.cimage} src={clogo} alt='C++ logo' />
                        </div>
                        <div className={classes.tickeritem}>
                            <img className={classes.image} src={react} alt='React logo' />
                        </div>
                        <div className={classes.tickeritem}>
                            <img className={classes.image} src={html} alt='HTML logo' />
                        </div>
                        <div className={classes.tickeritem}>
                            <img className={classes.cssimage} src={css} alt='CSS logo' />
                        </div>
                        <div className={classes.tickeritem}>
                            <img className={classes.sassimage} src={sass} alt='Sass logo' />
                        </div>
                        <div className={classes.tickeritem}>
                            <img className={classes.nodeimage} src={node} alt="Node logo" />
                        </div>
                        <div className={classes.tickeritem}>
                            <img className={classes.figimage} src={figma} alt='figma logo' />
                        </div>
                        <div className={classes.tickeritem}>
                            <img className={classes.rimage} src={r} alt='R logo' />
                        </div><div className={classes.tickeritem}>
                            <img className={classes.image} src={pythonlogo} alt='Python logo' />
                        </div>
                        <div className={classes.tickeritem}>
                            <img className={classes.image} src={js} alt='JS logo' />
                        </div>
                        <div className={classes.tickeritem}>
                            <img className={classes.tsimage} src={typescript} alt='Typescript logo' />
                        </div>
                        <div className={classes.tickeritem}>
                            <img className={classes.cimage} src={clogo} alt='C++ logo' />
                        </div>
                        <div className={classes.tickeritem}>
                            <img className={classes.image} src={react} alt='React logo' />
                        </div>
                        <div className={classes.tickeritem}>
                            <img className={classes.image} src={html} alt='HTML logo' />
                        </div>
                        <div className={classes.tickeritem}>
                            <img className={classes.cssimage} src={css} alt='CSS logo' />
                        </div>
                        <div className={classes.tickeritem}>
                            <img className={classes.sassimage} src={sass} alt='Sass logo' />
                        </div>
                        <div className={classes.tickeritem}>
                            <img className={classes.nodeimage} src={node} alt="Node logo" />
                        </div>
                        <div className={classes.tickeritem}>
                            <img className={classes.figimage} src={figma} alt='figma logo' />
                        </div>
                        <div className={classes.tickeritem}>
                            <img className={classes.rimage} src={r} alt='R logo' />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TechStack;

/*

*/